import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BalanceModificationTransactionsCreateDialog from './BalanceModificationTransactionsCreateDialog';

class BalanceModificationTransactionsCreate extends Component {
  render() {
    return (
      <div>
        <BalanceModificationTransactionsCreateDialog
          row={this.props}
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
          refreshTransactions={this.props.refreshTransactions}
        />
      </div>
    );
  }
}

BalanceModificationTransactionsCreate.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
};

export default BalanceModificationTransactionsCreate;
